import React, { useContext, useMemo } from "react";
import StandardServicesList from "features/services/personel-services/PersonelServicesList";
import ShiftPersonelServicesList from "features/services/personel-services/ShiftPersonelServicesList";
import TransferPersonelServicesList from "features/services/personel-services/TransferPersonelServicesList";
import TourBuilderList from "features/tour-builder/TourBuilderList";
import BundledRoutesList from "features/bundled-routes/BundledRoutesList";
import VehicleRoutes from "features/services/student-services/VehicleRoutesList";
import { useTranslation } from "react-i18next";
import { AuthContext } from "shared/context/auth-context";
import { PERMISSION_TYPES, COMPANY_FEATURES } from "@routebot/constants";
import { useSearchParams } from "react-router-dom";

import Tabs from "components/ui/tabs/Tabs";
import { resolveTabIndexFromQuery } from "pages/shared/utility";

const ServicesPage = () => {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);
  const [searchParams] = useSearchParams();

  const ServicesPageTabs = useMemo(() => {
    let allTabs = [];

    if (auth.permissions[PERMISSION_TYPES.ACCESS_TO_STUDENTS]) {
      allTabs.push({
        id: "vehicleRoutes",
        label: t("vehicleRoutes"),
        content: <VehicleRoutes />,
      });
    }

    // Bundled (multi-school) student routes — opt-in per company (feature-gated). Only surfaces
    // for companies that have COMPANY_FEATURES.BUNDLED_STUDENT_ROUTES enabled.
    if (
      auth.permissions[PERMISSION_TYPES.ACCESS_TO_STUDENTS] &&
      auth?.company?.features?.[COMPANY_FEATURES.BUNDLED_STUDENT_ROUTES]
    ) {
      allTabs.push({
        id: "bundledRoutes",
        label: t("bundledRoutes.tabTitle"),
        content: <BundledRoutesList />,
      });
    }
    if (auth.permissions[PERMISSION_TYPES.ACCESS_TO_PERSONELS]) {
      allTabs.push({
        id: "standardPersonelServices",
        label: t("standardPersonelServices"),
        content: <StandardServicesList />,
      });
    }

    if (auth.permissions[PERMISSION_TYPES.ACCESS_TO_SHIFTS]) {
      allTabs.push({
        id: "shiftPersonelServices",
        label: t("shiftPersonelServices"),
        content: <ShiftPersonelServicesList />,
      });
    }

    if (auth.permissions[PERMISSION_TYPES.ACCESS_TO_TRANSFERS]) {
      allTabs.push({
        id: "transferPersonelServices",
        label: t("transferPersonelServices"),
        content: <TransferPersonelServicesList />,
      });
    }

    if (auth.permissions[PERMISSION_TYPES.ACCESS_TO_PERSONELS]) {
      allTabs.push({
        id: "tours",
        label: t("tourBuilder.tabTitle"),
        content: <TourBuilderList />,
      });
    }

    // Add divider before bulk processes
    // allTabs.push({
    //   type: "divider",
    // });

    return allTabs;
  }, [auth.permissions, auth?.company?.features, t]);

  const tabParam = searchParams.get("tab");
  const initialTabIndex = resolveTabIndexFromQuery(tabParam, ServicesPageTabs);

  //Services'a herkes erisebilir simdilik
  //   if (!auth.permissions.acc) {
  //     return <NotFound />;
  //   }

  return <Tabs tabs={ServicesPageTabs} isVertical={true} id="services-page" initialTabIndex={initialTabIndex} />;
};

export default ServicesPage;
